/**
 * Launch access rules — mirror of functions/launch/access.js (keep in sync;
 * tests in utils/__tests__/launchAccess.test.js run both side by side).
 *   site_config/launch { stage: 'open' | 'beta' | 'closed', launchAt, waitlistEnabled }
 * Fallback: legacy site_maintenance/global.accessStage ('alpha' | 'beta' | 'live').
 */
export const STAGES = ['open', 'beta', 'closed'];
const LEGACY = { alpha: 'closed', beta: 'beta', live: 'open' };

// Screens anyone can open whatever the stage: sign-in, legal, billing returns.
export const GATE_EXEMPT_SCREENS = new Set([
    'MainPage', 'Admin', 'AdminLogin', 'Login', 'Register', 'ForgotPassword', 'ResetPassword',
    'Terms', 'Privacy', 'Docs', 'Plans', 'Why', 'Success', 'Suspended', 'Onboarding',
]);

export function resolveLaunch(cfg, legacy) {
    const c = cfg && typeof cfg === 'object' ? cfg : null;
    const stage = c && STAGES.includes(c.stage) ? c.stage : (LEGACY[legacy?.accessStage] || 'open');
    const launchAt = c?.launchAt && Number.isFinite(Date.parse(c.launchAt)) ? new Date(Date.parse(c.launchAt)).toISOString() : null;
    return { stage, launchAt, waitlistEnabled: c ? c.waitlistEnabled !== false : true, source: c ? 'launch' : 'legacy' };
}

export function effectiveStage(launch, now = Date.now()) {
    if (launch.launchAt && now >= Date.parse(launch.launchAt)) return 'open';
    return launch.stage;
}

export function hasAccess(launch, user = {}, now = Date.now()) {
    const stage = effectiveStage(launch, now);
    if (stage === 'open') return true;
    const isAdmin = String(user.userType || '').toLowerCase() === 'admin';
    if (isAdmin || user.alphaAccess === true) return true;
    if (stage === 'beta') return user.betaAccess === true;
    return false;
}
